<div class="main-container p-3">

  <div class="middle-container">

    <div>
      <div class="title-container">
        <label class="title">Enter/Confirm Email</label>
      </div>
      <form [formGroup]="emailForm">
        <div class="input-container" style="margin-right: 35px;">
          <label class="label">From</label>
          <div
            [ngClass]="{ 'invalid-input': emailForm.get('fromEmail')?.invalid && emailForm.get('fromEmail')?.touched }">
            <select formControlName="fromEmail" id="" class="input">
              <option value="" disabled>Select Email</option>
              <option *ngFor="let email of allFromEmails" [value]="email">{{ email }}</option>
            </select>
          </div>
        </div>



        <div class="input-container" style="margin-right: 35px;">
          <label class="label">To Email</label>
          <div class="email-wrapper input-with-chips">
            <div class="email-chips" formArrayName="emails">
              <ion-chip class="chipstyle" *ngFor="let emailCtrl of emails.controls; let i = index">
                {{ emailCtrl.value }}
                <ion-icon name="close-outline" (click)="removeEmail(i)"></ion-icon>
              </ion-chip>
            </div>
            <input class="input" type="text" formControlName="tempmail" placeholder="Add email and press Enter"
              (keyup.enter)="addEmail($event)">
            <span class="error-message">
              {{ getEmailErrorMessage(emailForm.get('tempmail'))}}
            </span>

          </div>
        </div>


      </form>
    </div>

  </div>


  <div class="button-container">
    <div class="d-flex justify-content-center">
      <ion-button class="filled-blue-btn" (click)="onSubmit()">Confirm</ion-button>
      <ion-button class="unfilled-blue-btn" (click)="onCancel()">Cancel</ion-button>
    </div>
  </div>


</div>